import http from '@/utils/http';

export default {
	// 字典分组
	groupList: data => {
		return http({ url: '/api/admin/v1/dictGroup/list', data }).then(r => r);
	},
	groupCreate: data => {
		return http({ url: '/api/admin/v1/dictGroup/create', data, tip: true }).then(r => r);
	},
	groupUpdate: data => {
		return http({ url: '/api/admin/v1/dictGroup/update', data, tip: true }).then(r => r);
	},
	groupDelete: data => {
		return http({ url: '/api/admin/v1/dictGroup/delete', data, tip: true }).then(r => r);
	},

	// 字典项
	itemList: data => {
		return http({ url: '/api/admin/v1/dictItem/list', data }).then(r => r);
	},
	itemCreate: data => {
		return http({ url: '/api/admin/v1/dictItem/create', data, tip: true }).then(r => r);
	},
	itemUpdate: data => {
		return http({ url: '/api/admin/v1/dictItem/update', data, tip: true }).then(r => r);
	},
	itemDelete: data => {
		return http({ url: '/api/admin/v1/dictItem/delete', data, tip: true }).then(r => r);
	},
};
